<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/Text/preface">Preface</a></p>
<p class="toc1"><a href="#/Text/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/chapter1">1. Before the Coming of the Rails</a></p>
<p class="toc1"><a href="#/Text/chapter2">2. The Railroad Geography of Rhode Island</a></p>
<p class="toc1"><span href="#/Text/chapter3" title="Link target outside of Sample">3. Boston Gets Ready for the Railroad</span></p>
<p class="toc1"><span href="#/Text/chapter4" title="Link target outside of Sample">4. The Railroad Comes to Providence</span></p>
<p class="toc1"><span href="#/Text/chapter5" title="Link target outside of Sample">5. South County Joins the World</span></p>
<p class="toc1"><span href="#/Text/chapter6" title="Link target outside of Sample">6. The Other Survivor: The Providence and Worcester Railroad</span></p>
<p class="toc1"><span href="#/Text/chapter7" title="Link target outside of Sample">7. Go West, Young Man</span></p>
<p class="toc1"><span href="#/Text/chapter8" title="Link target outside of Sample">8. The East Bay Makes Tracks</span></p>
<p class="toc1"><span href="#/Text/chapter9" title="Link target outside of Sample">9. Little Guys</span></p>
<p class="toc1"><span href="#/Text/chapter10" title="Link target outside of Sample">10. Juice Lines: Rhode Island Gets Wired</span></p>
<p class="toc1"><span href="#/Text/chapter11" title="Link target outside of Sample">11. The Struggle for Kingston Station</span></p>
<p class="toc1"><span href="#/Text/chapter12" title="Link target outside of Sample">12. The Railroads of Rhode Island Today</span></p>
<p class="toc"><span href="#/Text/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/Text/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1dafde4c